<template>
  <div class="testpaper">
    <div class="header">
      <div class="contain header_wrap">
        <div class="icon">
          <img src="../../assets/icons/icon.png" alt>
        </div>
        <div class="title">
          {{message.eptitle}}
          <div class="record">
            <span>
              总分
              <em>{{message.epscore}}</em>
              分
            </span>
            <span>
              题目数
              {{message.epcount}}
            </span>
          </div>
        </div>
        <div class="back" @click="back">返回</div>
      </div>
    </div>
    <div class="div"></div>
    <div class="main contain_main">
      <div class="issueitem" v-for="(issuelist,index) in list" :key="'issue'+index">
        <div class="title">
          {{issuelist.title}}
          <!-- <span>（共4题，20分）</span> -->
        </div>
        <issue
          v-for="(item,order) in issuelist.questions"
          :key="'question'+order"
          :total="issuelist.questions.length"
          :order="(order+1)"
          :disabled='true'
          :message="item"
          :showasw="false"
        ></issue>
      </div>
    </div>
    <div style="height:300px"></div>
  </div>
</template>
<script>
import issue from "../../components/issue";
import {
  ExamPaper_getInfo1,
  ExamPaper_getInfo2,
  ExamPaper_getInfo3
} from "../../assets/js/api.js";
export default {
  name: "scanexamforend",
  data() {
    return {
      list: [],
      message: {
        epscore: "",
        epcount: "",
        eptitle: ""
      }
    };
  },
  components: {
    issue
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.type) {
      this.getdata(this.$route.query.type, this.$route.query.id);
    } else {
      this.back();
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getdata(type, id) {
      switch (type+'') {
        case "1":
          ExamPaper_getInfo1({ epid: id }).then(res => {
            this.read(res);
          });
          break;
        case "2":
          ExamPaper_getInfo2({ epid: id }).then(res => {
            this.read(res);
          });
          break;
        case "3":
          ExamPaper_getInfo3({ epid: id }).then(res => {
            this.read(res);
          });
          break;
      }
    },
    read(res) {
      if (res.data.code == 200) {
        if (!res.data.data.epquestions[0].title) {
          this.list = [{ title: "试题", questions: res.data.data.epquestions }];
        } else {
          this.list = res.data.data.epquestions.map(item=>{
            item.questions=item.questions.map(sitem=>{
              sitem.questionscore =  item.score/item.count
              return sitem
            })
            return item
          });
        }
        this.message.eptitle = res.data.data.eptitle
        this.message.epscore = res.data.data.epscore
        this.message.epcount = res.data.data.epcount
      }
    }
  }
};
</script>
<style lang="css" scoped>
.header {
  height: 0.75rem;
  width: 100%;
  border: 1px solid #e8e9ee;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.header .title {
  min-width: 200px;
}
.div {
  display: block;
  content: "";
  height: 0.75rem;
  border: #474dff 1px solid;
}
.header_wrap {
  display: flex;
  justify-content: space-between;
  line-height: 0.75rem;
}
.record {
  position: absolute;
  bottom: 0rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.12rem;
  line-height: 0.2rem;
  width: 200%;
  color: #333;
  display: flex;
  justify-content: space-around;
}
em {
  color: red;
}
.header_wrap .title {
  font-size: 0.26rem;
  color: #474dff;
  position: relative;
}
.header_wrap .back {
  width: 1.1rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  display: inline-block;
  line-height: 0.3rem;
  margin-top: 0.22rem;
}
.main .title {
  font-size: 0.24rem;
  text-align: left;
  margin-top: 0.6rem;
}
.title span {
  font-size: 0.12rem;
  color: "#777f90";
}
</style>


// WEBPACK FOOTER //
// src/pages/scan/scanexam.vue